module.exports = __webpack_public_path__ + "static/media/de.b2285757.png";